//* ---------------------------------------
//  Vendors

import 'details-element-polyfill'
import 'focus-visible'
import 'focus-within-polyfill'
import 'objectFitPolyfill'
import 'whatwg-fetch'
import { Alert, Modal, Toast } from 'bootstrap' /* eslint no-unused-vars: off */

//* ---------------------------------------
//  Components

import announcement from './components/announcement'
import brandCopy from './components/brand-copy'
import contentCards from './components/content-cards'
import cookieBanner from './components/cookie-banner'
import featuredProducts from './components/featured-products'
import formLanding from './components/form-landing'
import globalHeader from './components/global-header'
import overlaySortegories from './components/overlay-sortegories'
import overlayVideo from './components/overlay-video'
import teamModal from './components/team-modal'
import swiper from './components/swiper'

//* ---------------------------------------
// Utils

import { getCssVar, setCssVar } from './utils/css'
import { getScrollbarWidth } from './utils/dom'

//* ---------------------------------------
//  Feature Detection

// Touch Detection
document.body.classList
    .add(`${('ontouchstart' in window
                && !window.navigator.userAgent.match(/X11/))
            || ('DocumentTouch' in window
                && document instanceof window.DocumentTouch)
            || (window.navigator.maxTouchPoints || 0) > 0
        ? ''
        : 'no-'}touch`)

document.body.classList
    .add(`${getScrollbarWidth()
        ? ''
        : 'no-'}scrollbar-width`)

// Scrollbar width, Overlay is 0
setCssVar('--scrollbar-width',
    `${getScrollbarWidth() || 0}px`)

// Ensure var for CSS calc
if (!getCssVar('--wp-admin--admin-bar--height'))
    setCssVar('--wp-admin--admin-bar--height', '0px')

//* ---------------------------------------
//  Render

announcement()
brandCopy()
contentCards()
cookieBanner()
featuredProducts()
formLanding()
globalHeader()
overlaySortegories()
overlayVideo()
swiper()
teamModal()

window.objectFitPolyfill()

let resizeDebounce

const onResize = (e) => {
    if (e) {
        if (document.documentElement.getAttribute('data-resizing') !== 'true')
            document.documentElement.setAttribute('data-resizing', true)

        window.objectFitPolyfill()

        if (resizeDebounce)
            clearTimeout(resizeDebounce)

        resizeDebounce = setTimeout(() => {
            document.documentElement.removeAttribute('data-resizing')
        }, 200)
    }

    if (!('checkVisibility' in document.body))
        return

    // Hide breakpoint specific modal
    const modalActive = document.querySelector('.modal.show')

    if (modalActive
            && !modalActive.checkVisibility()) {
        const modalInstance = Modal.getInstance(modalActive)

        modalInstance
            && modalInstance.hide()
    }

    // Detect FAB btn and set css vars
    const fabVar = '--btn-fab-offset'

    const fab = document.querySelector('.btn-fab')

    if (!fab)
        return getCssVar(fabVar)
            && setCssVar(fabVar)

    let fabOffset = ''

    if (fab
            && fab.checkVisibility())
        fabOffset = `${fab.offsetHeight
            + parseFloat(window.getComputedStyle(fab)
                .bottom)}px`

    if (getCssVar(fabVar) !== fabOffset)
        setCssVar(fabVar, fabOffset)
}

onResize()

window.addEventListener('resize', onResize)

// Initiate Bootstrap Toast
const toastElList = document.querySelectorAll('.toast')
const toastList = [...toastElList].map(toastEl => new Toast(toastEl))

// Override fetch headers for Flipbook plugin
const { fetch: originalFetch } = window

window.fetch = async (...args) => {
    const [resource, config] = args

    try {
        if (config.headers.get('range')
                && !config.headers.get('cache-control'))
            config.headers.set('cache-control', 'no-cache')
    }
    catch (err) {}

    return originalFetch(resource, config)
}

//* ---------------------------------------
//  Hot Module Replacement

if (import.meta.hot)
    import.meta.hot.accept()
